const formatter = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

export function formatCurrency(amount) {
  // Keep the same ordinary space as the server-rendered number_to_currency.
  return `${formatter.format(amount).replace(/[\u00a0\u202f]/g, " ")} €`
}

export function formatCents(cents) {
  return formatCurrency(Number(cents || 0) / 100)
}
